import Container = PIXI.Container;
import { WindowManager, WindowName } from '../core/managers/WindowManager';
import { removeAllSignals } from '../utils/EventUtils';

export class AbstractWindow extends Container {
  constructor(public readonly name: WindowName, params?: any) {
    super();
  }

  public onRegister(): void {
    this.drawLayout();
  }

  protected drawLayout(): void {
    //
  }

  public show(): void {
    WindowManager.getInstance().show(this.name);
  }

  public hide(): void {
    WindowManager.getInstance().hide(this.name);
  }

  public destroy(options?: any): void {
    removeAllSignals(this);
    super.destroy(options);
  }
}